import { createGenericReducer } from "common/genericReducer";
import { LOCALE_RECEIVED, LOCALE_REQUESTED, LOCALE_REQUEST_FAILED } from "./localeActions";

export const locale = createGenericReducer(LOCALE_REQUESTED, LOCALE_RECEIVED, LOCALE_REQUEST_FAILED);
